import { Box } from '@aicon-dev/caas-core';
import { theme } from '@aicon-dev/caas-ui/dist/theme.css';
import { useTranslation } from 'react-i18next';

import { Image } from '~/assets/icons';

interface Props {
  position?: any;
  height?: string;
  backgroundColor?: string;
  noTextContent?: boolean;
  zIndex?: number;
}

const NoReportImage = ({ position, height, backgroundColor, noTextContent, zIndex }: Props) => {
  const { t } = useTranslation('report');

  return (
    <Box
      position={position}
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height={height ? height : '190px'}
      background={backgroundColor ? backgroundColor : theme.color.gray[100]}
      zIndex={zIndex}
    >
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Image size="46" color={theme.color.gray[300]} />
        {!noTextContent && (
          <Box marginTop="8px" color={theme.color.gray[500]}>
            {t('report:m_there_is_no_work_reported')}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NoReportImage;
